import React from 'react'
import './Home.css'
import Typed from "react-typed";
import { Link } from 'react-scroll';

const Home = () => {
    return (
        <>
            <div id="home">
                <div className="container">
                    <div className="first"></div>
                    <div className="Second"></div>

                    <div className="inside-box">
                        <div className="text-writting">
                            <h1>Hello.</h1>

                            <h4><Typed
                                strings={[" I'M HARISH CARPENTER. ", " FULL STACK DEVELOPER. ", " ARTIST. "]}
                                typeSpeed={80}
                                backSpeed={50}
                                loop
                            /></h4>

                            <p className='IntroPara'> <q> Every Good Developer/Programmer You Know Got There By Solving Problems They Were Unqualified To Solve Until They Actually Did It. <b>~ Patric McKenzie</b> </q> </p>

                            <button className='button btn1'><Link to="footer" spy={true} smooth={true} offset={-100} duration={2000}>Contact me now.</Link></button>
                            <button className='button btn2'><Link to="about" spy={true} smooth={true} offset={-100} duration={2000}>Know More About Me.</Link></button>

                        </div>
                    </div>
                </div>
                <div className="links-icons">
                    <ul className='SocialLinks' >
                        <li><a href={"https://github.com/harishcarpenter1"} target="_blabk" rel="noopener noopener">Github</a></li>
                        <li><a href={"https://www.linkedin.com/in/harishcarpenter/"} target="_blabk" rel="noopener noopener">Linkedin</a></li>
                        <li><a href={"https://leetcode.com/harishcarpenter/"} target="_blabk" rel="noopener noopener">Leetcode</a></li>
                        <li><a href={"https://www.codechef.com/users/car12"} target="_blabk" rel="noopener noopener">Codechef</a></li>
                        <li><a href={"https://auth.geeksforgeeks.org/user/harishcarpenter/"} target="_blabk" rel="noopener noopener">GeeksforGeeks</a></li>
                        
                    </ul>
                </div>

            </div>
        </>
    )
}

export default Home